import { RelatedSpecs } from "./RelatedSpecs";

export default RelatedSpecs;
